// components/TotalSummary.tsx
import type { StatDeltas } from '../balancing.types';
import { formatStatValue, getStatColor } from '../balancing.utils';

type Props = {
  total: {
    min: StatDeltas;
    max: StatDeltas;
    avg: StatDeltas;
  };
};

export function TotalSummary({ total }: Props) {
  const stats = [
    { label: 'Cash', key: 'cash' as const },
    { label: 'Depot', key: 'investments' as const },
    { label: 'Happiness', key: 'happiness' as const },
  ];

  return (
      <div className="bg-white border-2 border-gray-200 rounded-lg p-6 mb-6">
        <h2 className="text-xl font-bold mb-4">Game Totals (All Phases)</h2>

        <table className="w-full">
          <thead>
          <tr className="border-b border-gray-200">
            <th className="text-left py-3 px-4 font-semibold text-gray-700">Stat</th>
            <th className="text-center py-3 px-4 font-semibold text-gray-700">Minimum</th>
            <th className="text-center py-3 px-4 font-semibold text-gray-700">Average</th>
            <th className="text-center py-3 px-4 font-semibold text-gray-700">Maximum</th>
          </tr>
          </thead>
          <tbody>
          {stats.map((stat) => (
              <tr key={stat.key} className="border-b border-gray-100 last:border-0">
                <td className="py-3 px-4 font-medium text-gray-900">{stat.label}</td>
                <td className="py-3 px-4 text-center">
                <span className={`inline-block px-3 py-1 rounded-lg font-bold ${getStatColor(total.min[stat.key])}`}>
                  {formatStatValue(total.min[stat.key])}
                </span>
                </td>
                <td className="py-3 px-4 text-center">
                <span className={`inline-block px-3 py-1 rounded-lg font-bold ${getStatColor(total.avg[stat.key])}`}>
                  {formatStatValue(total.avg[stat.key])}
                </span>
                </td>
                <td className="py-3 px-4 text-center">
                <span className={`inline-block px-3 py-1 rounded-lg font-bold ${getStatColor(total.max[stat.key])}`}>
                  {formatStatValue(total.max[stat.key])}
                </span>
                </td>
              </tr>
          ))}
          </tbody>
        </table>
      </div>
  );
}